import { CurrencyCode, DateIntervalType, SubscriptionPlanProductType } from '../graphql/api-platform-graphql';
export const TEAM_PLAN_V1_FALLBACK_RESPONSE = {
  isLoading: false,
  isSubscriber: false,
  id: '0',
  title: 'Team Plan',
  productType: SubscriptionPlanProductType.Team,
  urlLearnMore: 'https://business.udemy.com/team/',
  urlExpressCheckout: 'https://business.udemy.com/sign-up/?utm_source=direct&utm_medium=direct',
  urlTermsOfUse: 'https://www.udemy.com/terms/ub/',
  contentCollections: [],
  priceOptions: [{
    id: '283980',
    listPrice: {
      amount: '360',
      currency: CurrencyCode.Usd
    },
    annualSavings: null,
    renewalInterval: {
      type: DateIntervalType.Year,
      count: 1
    },
    trial: {
      dateInterval: {
        type: DateIntervalType.Day,
        count: 14
      }
    },
    licenseContext: {
      unitPrice: {
        amount: '360',
        currency: CurrencyCode.Usd
      },
      licenseCount: 1,
      defaultLicenseCount: 10,
      minimumLicenseCount: 5,
      maximumLicenseCount: 20
    }
  }]
};
export const CONSUMER_PRODUCT_TYPES = new Set([SubscriptionPlanProductType.Consumersubscription, SubscriptionPlanProductType.ConsumersubscriptionValuePlan, SubscriptionPlanProductType.GrowWithGoogle, SubscriptionPlanProductType.ConsumersubscriptionPlusGrowWithGoogle]);
//# sourceMappingURL=constants.js.map